import React from "react";
import { useMessageSource } from "react-message-source";
import GTM from "../../../util/tracking/gtm";
import {
  EventCategory,
  PERSON_ADDED_ACTION_VALUE,
} from "../../../util/tracking/types";
import MultiForm from "../../shared/components/multi-form";
import { emptyPerson } from "../defaults";
import Person from "../person";
import { PersonType, SetNameAndSignatureType } from "../types";
import SignatoryDropDown from "./signatoryDropDown";
import { SignatoryType } from "../../../api/cybwell/types";

export default function SameAsCardholder({
  signatories,
  setNameAndSignatureType,
  prefilledPersons,
}: {
  signatories: PersonType[];
  setNameAndSignatureType: SetNameAndSignatureType;
  prefilledPersons: SignatoryType[];
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <MultiForm
      name="cardholderSignatories"
      formData={signatories}
      addButtonText={`${getMessage(
        "Signing.second-signatory-add",
      )} ${getMessage("Signing.second-signatory-add-alert")}`}
      removeButtonText={getMessage("Signing.second-signatory-remove")}
      createDefaultItemData={() => emptyPerson}
      renderFormComponent={(data, path, index) =>
        index === 0 ? (
          <Person {...data} dataPath={path} />
        ) : (
          <SignatoryDropDown
            setNameAndSignatureType={setNameAndSignatureType}
            name="cardholderSignatories[1]"
            signatories={prefilledPersons}
            selectedSignatory={signatories[1]}
          />
        )
      }
      limit={2}
      onAddItem={() => {
        GTM.trackEvent(
          EventCategory.AuthorizedSignatory,
          PERSON_ADDED_ACTION_VALUE,
        );
      }}
    />
  );
}
